import React from 'react';
import { connect } from 'react-redux';

import getQualityBySlotName from 'selectors/possessions/getQualityBySlotName';
import EquippedSlotComponent from './EquippedSlotComponent';
import { IQuality } from 'types/qualities';
import { IAppState } from 'types/app';

function EquippedSlotContainer(props: Props) {
  const { isChanging, name, quality } = props;
  return (
    <EquippedSlotComponent
      isChanging={isChanging}
      name={name}
      quality={quality}
    />
  );
}

interface Props {
  isChanging: boolean,
  name: string
  quality?: IQuality,
}

EquippedSlotContainer.displayName = 'EquippedSlotContainer';

const mapStateToProps = (state: IAppState, props: Props) => ({
  isChanging: state.outfit.isChanging,
  quality: getQualityBySlotName(state, props),
});

export default connect(mapStateToProps)(EquippedSlotContainer);